import get from 'lodash/get';
import React from 'react';
import ReactDOM from 'react-dom';

import AppContext from '../services/Context';
import styled from '../styled-components';

type PropType = {
  children: React.ReactNode;
  isOpen?: boolean;
  onClose?: any;
};

class Modal extends React.Component<PropType> {
  el = document.createElement('div');
  modalRoot = document.getElementById('portals-root');

  wrapperRef: any;

  componentDidMount() {
    if (this.modalRoot) this.modalRoot.appendChild(this.el);
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keyup', this.handleEscapeKey);
  }

  componentWillUnmount() {
    if (this.modalRoot) this.modalRoot.removeChild(this.el);
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keyup', this.handleEscapeKey);
  }

  setWrapperRef = (node: any) => (this.wrapperRef = node);

  handleClickOutside = (e: any) => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target) && !!this.props.isOpen) {
      this.props.onClose();
    }
  };

  handleEscapeKey = (e: any) => {
    if (
      e.key === 'Escape' &&
      this.wrapperRef &&
      !this.wrapperRef.contains(e.target) &&
      !!this.props.isOpen
    ) {
      this.props.onClose();
    }
  };

  render() {
    return ReactDOM.createPortal(
      <Wrapper>
        <AppContext.Consumer>
          {({ theme }) => (
            <ModalWindow innerRef={(comp: any) => (this.wrapperRef = comp)} theme={theme}>
              {this.props.children}
            </ModalWindow>
          )}
        </AppContext.Consumer>
      </Wrapper>,
      this.el,
    );
  }
}

const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0.4);
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  z-index: 999;
`;

const ModalWindow = styled.div`
  display: block;
  overflow: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  max-height: 100%;
  z-index: 9999;
  ${({ theme }) => get(theme, 'modal')};
`;

export default Modal;
